
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/passforgotten",
      function () {
        return require("private-next-pages/passforgotten.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/passforgotten"])
      });
    }
  